export default __webpack_public_path__ + "static/media/Brain-02.7c9e5996.svg";